module.exports = __webpack_public_path__ + "img/EditLocationAltOutlined.63ee58cd.svg";